import { Injectable } from '@angular/core';
import { SetOptions } from '@capacitor/text-zoom';
import { from, Observable } from 'rxjs';
import { TextZoomWrapper } from 'src/app/wrappers/text-zoom.wrapper';

@Injectable({
  providedIn: 'root'
})
export class TextZoomAdapter {
  constructor(
    private textZoomWrapper: TextZoomWrapper
  ) {}

  getAppZoom(): Observable<number> {
    const getPromise = this.textZoomWrapper.get()
      .then((result) => result.value);
    const getObs = from(getPromise);

    return getObs;
  }

  getSystemZoom(): Observable<number> {
    const getPreferredPromise = this.textZoomWrapper.getPreferred()
      .then((result) => result.value);
    const getPreferredObs = from(getPreferredPromise);

    return getPreferredObs;
  }

  setAppZoom(value: number): Observable<void> {
    const setOptions: SetOptions = { value };
    const setPromise = this.textZoomWrapper.set(setOptions);
    const setObs = from(setPromise);

    return setObs;
  }
}